import { render } from "./App.vue?vue&type=template&id=17aab5be"
const script = {}

import "./App.vue?vue&type=style&index=0&id=17aab5be&lang=scss"
script.render = render

export default script